import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=0325cb92"
import script from "./Opportunities.vue?vue&type=script&lang=ts"
export * from "./Opportunities.vue?vue&type=script&lang=ts"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=0325cb92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports